import {
  ExpressionEvaluator,
  ExpressionEvaluatorSanitiseKeyFn,
  ExpressionEvaluatorType,
  UnaryOperator
} from './interfaces/expression-evaluator';
import { IdentifierExpression } from './identifier-expression';
import { LiteralExpression } from './literal-expression';
import { PrimitiveTypes } from '../shared/interfaces/generics';

export class UnaryExpression
  implements ExpressionEvaluator<Record<string, PrimitiveTypes>, boolean>
{
  argument: IdentifierExpression | LiteralExpression | undefined;

  operator: UnaryOperator;

  constructor(operator: UnaryOperator) {
    this.operator = operator;
  }

  getType() {
    return ExpressionEvaluatorType.UNARY_EXPRESSION;
  }

  evaluate(
    model: Record<string, PrimitiveTypes>,
    getSanitiseKey: ExpressionEvaluatorSanitiseKeyFn
  ) {
    if (this.argument && this.operator === UnaryOperator.NOT) {
      return !this.argument.evaluate(model, getSanitiseKey);
    }

    if (this.argument && this.operator === UnaryOperator.EXISTS) {
      return !!this.argument.evaluate(model, getSanitiseKey);
    }

    return false;
  }
}
